
//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'
import { Data as OtherContent } from '../listenKey/index'
import { Data as QandAContent } from '../q&a/index'

//共用
import { List as SocketContent } from '../spot/websocket/index'
import { Data as BasicContent } from '../spot/api/basic/index'

import { Data as PFuturesTraderContent } from './api/pFuturesTrader/index'
import { Data as SpotTraderContent } from './api/spotTrader/index'


let aaa = JSON.stringify(OtherContent)
aaa = aaa.replaceAll("/market/<listenKey>", "/market?listenKey==")
aaa = aaa.replaceAll("wss://open-api-ws.bingx.com/market?listenKey=", "wss://open-api-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")


const ROOT_MODULE = "en-us/copyTrade"
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "Frequently Asked Questions",
  "content": QandAContent
}

export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket API Reference",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "Change Log",
  "content": ChangeLogContent
}

const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "Authentication",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "General Info",
  "content": BasicContent
}

const PFuturesTrader = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trader-pFutures-interface.html`,
  "name": "PFutures Trader",
  "content": PFuturesTraderContent
}
const SpotTrader = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trader-spot-interface.html`,
  "name": "Spot Trader",
  "content": SpotTraderContent
}


export const copyTradeConfig = [
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  PFuturesTrader,
  SpotTrader
]


// WEBPACK FOOTER //
// ./src/config/en-US/copyTrade/index.js